module.exports = __webpack_public_path__ + "static/media/pencil.223c81e5.svg";